import {
  createCurrentMeasurementsEndpoint,
  createMeasurementsEndpoint,
  createTargetMeasurementsEndpoint,
  updateCurrentMeasurementsEndpoint,
  updateMeasurementsEndpoint,
  updateTargetMeasurementsEndpoint,
} from "./api/Measurements";

export const createMeasurementsInDatabase = async measurementsData => {
  try {
    const response = await createMeasurementsEndpoint(measurementsData);
    return response.data;
  } catch (error) {
    throw new Error(`Error creating measurements: ${error.message}`);
  }
};

export const updateMeasurementsInDatabase = async measurementsData => {
  try {
    const response = await updateMeasurementsEndpoint(measurementsData);
    return response.data;
  } catch (error) {
    throw new Error(`Error updating measurements: ${error.message}`);
  }
};

// Current measurements service functions (for plan-based measurements in Align)
export const createCurrentMeasurementsInDatabase = async measurementsData => {
  try {
    const response = await createCurrentMeasurementsEndpoint(measurementsData);
    return response.data;
  } catch (error) {
    throw new Error(`Error creating current measurements: ${error.message}`);
  }
};

export const updateCurrentMeasurementsInDatabase = async measurementsData => {
  try {
    const response = await updateCurrentMeasurementsEndpoint(measurementsData);
    return response.data;
  } catch (error) {
    throw new Error(`Error updating current measurements: ${error.message}`);
  }
};

// Target measurements service functions (for plan-based measurements in Align)
export const createTargetMeasurementsInDatabase = async measurementsData => {
  try {
    const response = await createTargetMeasurementsEndpoint(measurementsData);
    return response.data;
  } catch (error) {
    throw new Error(`Error creating target measurements: ${error.message}`);
  }
};

export const updateTargetMeasurementsInDatabase = async measurementsData => {
  try {
    const response = await updateTargetMeasurementsEndpoint(measurementsData);
    return response.data;
  } catch (error) {
    throw new Error(`Error updating target measurements: ${error.message}`);
  }
};
